import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../base/base.component";
import { AppComponent } from "../../../app.component";
import { Router } from "@angular/router";
import { GenericService } from "../../../../crossconcern/services/generic.services";
import { Location } from "@angular/common";
import { ADD_PATH, BACKOFFICE_PATH, NURSERY_PATH } from "../../../../crossconcern/utilities/properties/path.property";
import { AlertUtils } from "../../../../crossconcern/utilities/utils/alert.utils";
var NurseryComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryComponent, _super);
    function NurseryComponent(appComponent, router, genericService, location, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.genericService = genericService;
        _this.location = location;
        _this.alertUtils = alertUtils;
        return _this;
    }
    NurseryComponent.prototype.ngOnInit = function () {
        this.subscribeGenericServices();
    };
    NurseryComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    NurseryComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onNewCalledSubscription = this.genericService.onNewCalled.subscribe(function () {
            _this.goToRoute(BACKOFFICE_PATH + NURSERY_PATH + "/" + ADD_PATH);
        });
    };
    NurseryComponent.prototype.unsubscribeServices = function () {
        this.onNewCalledSubscription.unsubscribe();
    };
    return NurseryComponent;
}(BaseComponent));
export { NurseryComponent };
